import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import InputText from '../../Common/InputText';
import Drawer from '../../Common/Drawer/Drawer';

export class BaselineCopyForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            name: "",
            description: "",
            isFormValid: true
        };
    }

    onTextChange = (e) => {
        this.setState({ ...this.state, [e.target.name]: e.target.value });
    }

    copyBaselineClick = () => {
        if (!this.state.name) {
            this.setState({ isFormValid: false });
            return;
        }

        this.props.copyBaseline(this.state.name, this.state.description);
    }

    render () {
        return (
            <Drawer isWide={false} title={"Copy Baseline: " + this.props.orginBaselineName} saveText="Create" onSaveClick={this.copyBaselineClick} onCancelClick={this.props.cancelClick}>
                <LoadingIndicator isLoading={this.props.isLoading}>
                    <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>
                        <InputText 
                            name="name" 
                            label="Name" 
                            placeholder="Name" 
                            type="text" 
                            value={this.state.name} 
                            onChange={this.onTextChange} 
                            isRequired={true} 
                            errorMessage="Name is required" 
                            maxLength={100}/>
                        <InputText 
                            name="description" 
                            label="Description" 
                            placeholder="Description" 
                            type="text" 
                            value={this.state.description} 
                            onChange={this.onTextChange} 
                            isRequired={false} 
                            maxLength={1200} />
                    </form>
                </LoadingIndicator>
            </Drawer>
        );
    }
}

BaselineCopyForm.propTypes = {
    orginBaselineName: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    copyBaseline: PropTypes.func.isRequired,
    cancelClick: PropTypes.func.isRequired
}

export default BaselineCopyForm;